import { observer } from 'mobx-react';
import * as React from 'react';
import { GroupResource } from '../../../../GroupsStore/Types';
import GroupRow from './Row';
import ModalStore from '../../../Modal/Store';
import GroupStore from '../../../../GroupStore';
import { MulticheckStore } from '../../../../Multicheck/Store';

interface Props {
  groups: GroupResource[];
  modalStore: ModalStore;
  groupStore: GroupStore;
  multicheckStore: MulticheckStore<GroupResource>;
}

const Body: React.FC<Props> = ({ groups, modalStore, groupStore, multicheckStore }) => (
  <tbody className="divide-y divide-gray-200 bg-white">
    {groups.map((resource) => (
      <GroupRow
        resource={resource}
        key={resource.payload.id}
        modalStore={modalStore}
        groupStore={groupStore}
        multicheckStore={multicheckStore}
      />
    ))}
  </tbody>
);

export default observer(Body);
